module.exports={render:function (){
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [_c('a-row', [_c('a-col', {
    staticClass: "login-col-left"
  }), _vm._v(" "), _c('a-col', {
    staticClass: "login-col-jumbotron"
  }, [_c('div', {
    staticClass: "jumbotron"
  }, [_c('div', {
    staticClass: "jumbotron-content-title"
  }, [_vm._v("悦享汽车生活")]), _vm._v(" "), _c('div', {
    staticClass: "jumbotron-image"
  }, [_c('img', {
    staticClass: "jumbotron-image-bg",
    attrs: {
      "src": require("../../../static/img/login.png"),
      "alt": "背景图"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "jumbotron-content-text"
  }, [_vm._v("优车享致力于构建汽车服务生态闭环，让人车生活更和谐")])])]), _vm._v(" "), _c('a-col', {
    staticClass: "login-col-center"
  }), _vm._v(" "), _c('a-col', {
    staticClass: "login-col-form"
  }, [_c('a-form', {
    attrs: {
      "autoFormCreate": function (form) { return this$1.form = form; }
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.doLogin.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-title"
  }, [_c('a-tabs', {
    staticClass: "ant-tabs-nav ant-tabs-tab-active",
    attrs: {
      "default-active-key": "1"
    },
    on: {
      "change": _vm.loginTypeClick
    }
  }, [_c('a-tab-pane', {
    key: "1",
    attrs: {
      "tab": "邮箱登录",
      "force-render": ""
    }
  }, [(!_vm.phoneLoginFlag) ? _c('div', [_c('a-form-item', {
    attrs: {
      "fieldDecoratorId": "email",
      "fieldDecoratorOptions": {
        rules: [{
          required: true,
          message: '请输入用户邮箱',
          whitespace: true
        }]
      }
    }
  }, [_c('a-input', {
    attrs: {
      "size": "large",
      "placeholder": "请输入您的用户邮箱"
    }
  }, [_c('img', {
    staticClass: "input-icon",
    attrs: {
      "slot": "prefix",
      "src": require("../../../static/img/icon_person.png"),
      "alt": ""
    },
    slot: "prefix"
  })])], 1), _vm._v(" "), _c('a-form-item', {
    attrs: {
      "fieldDecoratorId": "password",
      "fieldDecoratorOptions": {
        rules: [{
          required: true,
          message: '请输入密码',
          whitespace: true
        }]
      }
    }
  }, [_c('a-input-password', {
    attrs: {
      "size": "large",
      "type": "password",
      "placeholder": "请输入您的密码"
    }
  }, [_c('img', {
    staticClass: "input-icon",
    attrs: {
      "slot": "prefix",
      "src": require("../../../static/img/icon_password.png"),
      "alt": ""
    },
    slot: "prefix"
  })])], 1)], 1) : _vm._e()]), _vm._v(" "), _c('a-tab-pane', {
    key: "2",
    attrs: {
      "tab": "手机号登录"
    }
  }, [(_vm.phoneLoginFlag) ? _c('div', [_c('a-form-item', {
    attrs: {
      "fieldDecoratorId": "mobile",
      "fieldDecoratorOptions": {
        rules: [{
          required: true,
          message: '请输入手机号',
          whitespace: true
        }]
      }
    }
  }, [_c('a-input', {
    attrs: {
      "size": "large",
      "placeholder": "请输入您的手机号"
    }
  }, [_c('img', {
    staticClass: "input-icon",
    attrs: {
      "slot": "prefix",
      "src": require("../../../static/img/icon_person.png"),
      "alt": ""
    },
    slot: "prefix"
  })])], 1), _vm._v(" "), _c('a-form-item', {
    attrs: {
      "fieldDecoratorId": "validCode",
      "fieldDecoratorOptions": {
        rules: [{
          required: true,
          message: '请输入验证码',
          whitespace: true
        }]
      }
    }
  }, [_c('a-input', {
    attrs: {
      "size": "large",
      "placeholder": "请输入验证码"
    }
  }, [_c('img', {
    staticClass: "input-icon",
    attrs: {
      "slot": "prefix",
      "src": require("../../../static/img/icon_password.png"),
      "alt": ""
    },
    slot: "prefix"
  }), _vm._v(" "), _c('div', {
    staticClass: "validCode",
    attrs: {
      "slot": "suffix"
    },
    slot: "suffix"
  }, [(_vm.validCodeFlag) ? _c('img', {
    staticClass: "validCode-image",
    attrs: {
      "src": "validCodeUrl",
      "alt": "验证码"
    }
  }) : _c('span', {
    staticClass: "validCode-span",
    class: _vm.sendCaptchaFlag ? 'validCode-span-disabled' : '',
    on: {
      "click": _vm.getCaptcha
    }
  }, [_vm._v(_vm._s(_vm.sendCaptchaFlag ? _vm.validCodeTimeOut + '秒后重发' : '获取验证码'))])])])], 1)], 1) : _vm._e()])], 1)], 1), _vm._v(" "), (_vm.phoneLoginFlag) ? _c('div') : _c('div', {
    staticClass: "check-input"
  }, [_c('a-checkbox', {
    staticStyle: {
      "width": "68%"
    },
    on: {
      "change": _vm.onChange
    },
    model: {
      value: (_vm.rememberFlag),
      callback: function($$v) {
        _vm.rememberFlag = $$v
      },
      expression: "rememberFlag"
    }
  }, [_c('span', [_vm._v("记住本次登录状态")])]), _vm._v(" "), _c('div', {
    staticClass: "other-input"
  }, [_c('router-link', {
    staticStyle: {
      "color": "#333333"
    },
    attrs: {
      "to": "/forget"
    }
  }, [_vm._v("忘记密码")])], 1)], 1), _vm._v(" "), _c('a-form-item', {
    staticClass: "submit-button"
  }, [_c('a-button', {
    attrs: {
      "loading": _vm.loading,
      "size": "large",
      "htmlType": "submit",
      "type": "primary"
    }
  }, [_vm._v("\n            登录\n          ")])], 1)], 1)], 1), _vm._v(" "), _c('a-col', {
    staticClass: "login-col-right"
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-147b526c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/login/Login.vue
// module id = 41mE
// module chunks = 273